import { useState } from 'react';
import { categories } from '@/mocks/home';

export default function CategoryList() {
  const [active, setActive] = useState(categories[0].id);
  const current = categories.find((c) => c.id === active) ?? categories[0];

  return (
    <section id="gualist" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="flex flex-col gap-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">全年瓜单</p>
            <h2 className="font-heading text-2xl font-black tracking-tight md:text-4xl">按瓜田，慢慢挑</h2>
            <p className="text-sm text-foreground-700 md:text-base">四条瓜田线，标题带路，想看哪条点哪条。</p>
          </div>

          <div className="inline-flex w-fit items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1 md:shrink-0">
            {categories.map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => setActive(c.id)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                  active === c.id ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {c.name}
              </button>
            ))}
          </div>
        </div>

        <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-1.5 text-xs font-medium text-foreground-600">
          <i className="ri-slice-line text-primary-600"></i>
          当前瓜田：{current.tagline}
        </p>

        <div className="mt-6 overflow-hidden rounded-3xl border border-background-200 bg-background-50">
          {current.items.map((g, idx) => (
            <div
              key={g.title}
              className={`flex flex-col gap-3 px-6 py-5 transition-colors hover:bg-background-100 md:px-8 ${
                idx !== current.items.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-semibold text-accent-800">{g.tag}</span>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">{g.title}</h3>
                <span className="ml-auto whitespace-nowrap text-xs font-medium text-foreground-500">{g.month}</span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">{g.summary}</p>
              <div className="flex items-center gap-3">
                <a href="#talk" className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-700 hover:text-primary-800">
                  进楼围观 <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}